import React from 'react';
import { DisabledEnabledItem } from '../ui/DisabledEnabledItem';

export const printersColumns = [
    {
        key: "printer_name", label: 'printerSettings.columns.printerName',
        componentTransform: (name: string, key: any,props:any) => {
            return <span key={`${key}-printer-name`}>{`${props.name_public}`}</span>
        }
    },
    {
        key: "printer_mac-address", label: 'printerSettings.columns.printerMacAddress',
        componentTransform: (macAddress: string, key: any, props:any) => {
            return <span key={`${key}-mac`}>MAC: {props.mac_address}</span>
        }
    },
    {
        key: "is_printer_enabled", label: '',
        componentTransform: (status: any, key: any, props: any) => {
            return <span key={`${key}-priter`}>
                <DisabledEnabledItem enabled={props.enabled} />
            </span>
        }
    },
];